import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table";

import {
  type ExperimentDailyActivity,
  type ExperimentMetrics,
  formatRate,
} from "../experiments/experimentClient";
import { buildPaygateTriggerRows } from "./monetizationModel";

/** How often each paygate surface fires and how many paid orders it produced. */
export function MonetizationPaygateTriggers({
  metrics,
  daily,
}: {
  metrics: ExperimentMetrics;
  daily?: ExperimentDailyActivity[];
}) {
  const rows = buildPaygateTriggerRows(metrics, daily);
  return (
    <Card>
      <CardHeader>
        <CardTitle>Paygate frequency</CardTitle>
      </CardHeader>
      <CardContent className="overflow-x-auto">
        <Table>
          <TableHeader>
            <TableRow>
              <TableHead>Gate</TableHead>
              <TableHead>Contacts</TableHead>
              <TableHead>Times shown</TableHead>
              <TableHead>Paid orders after it</TableHead>
              <TableHead>Contacts → paid</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {rows.map((row) => (
              <TableRow key={row.key}>
                <TableCell>
                  <p className="font-medium">{row.label}</p>
                  <p className="text-xs text-muted-foreground">
                    {row.description}
                  </p>
                </TableCell>
                <TableCell className="tabular-nums">
                  {row.contacts ?? "—"}
                </TableCell>
                <TableCell className="tabular-nums">
                  {row.exposures ?? "—"}
                </TableCell>
                <TableCell className="tabular-nums">{row.paidOrders}</TableCell>
                <TableCell>{formatRate(row.toPaidPct)}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
        <p className="mt-3 text-xs text-muted-foreground">
          A paid order is attributed to the last gate the contact saw before
          picking a package. The same contact can be blocked, buy, use the
          Echoes and buy again, so orders can exceed contacts.
        </p>
      </CardContent>
    </Card>
  );
}
